import React from 'react';
import WebsiteApp from './website-app';

function App() {
  return <WebsiteApp />;
}

export default App;
